//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
    useState,
    useCallback,
    useContext,
    useEffect,
    useRef
} from "react";
import * as moment from "moment";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";

// custom pages
import { useStyles } from "../Dashboard/styles.js";
import report from "apis/Report/Report";
import Context from "context/context";

// material-ui
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

// material-ui icons
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
// import StatementXLSX from "./StatementXLSX";
// import StatementPDF from "./StatementPDF";
// import DownloadIcon from '@material-ui/icons/Download';

//Analytics
import { logEvent } from "helpers/analytics";
import { useTrackWithGTM } from 'helpers/gtm';
import BenefitStatementPDF from "./PDF/BenefitStatementPDF";
import ThriveFreeStatement from "components/BenefitStatement/ThriveFreeStatement/ThriveFreeStatement.jsx";
import ThriveFreeStatementPDF from "./PDF/ThriveFreeStatementPDF.jsx";



// custom TextField
const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormLabel-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: 20,
            },
            "&.MuiOutlinedInput-root": {
                marginTop: 0,
                borderRadius: "0px 10px 10px 0px !important",
                height: 40,
            },
        },
    },
})(TextField);

const benefitConfig = [
    {
        label: "Your Points Earnings",
        rows: [
            {
                key: "henrySchein",
                text: "5X Points from Henry Schein Products",
            },
            {
                key: "equipment",
                text: "3X Points from Equipment",
            },
            {
                key: "supplierBonus",
                text: "Exclusive Bonus Points",
            },
            {
                key: "baseX",
                text: "1.5X Points on All Other Purchases",
            },
        ],
    },
    {
        label: "Your Shipping Savings",
        rows: [
            {
                key: "merchandiseShipping",
                text: "On Merchandise",
            },
        ],
    },
    {
        label: "Your Service Savings",
        rows: [
            {
                key: "serviceLaborDiscount",
                text: "44% Service Labor Discount",
            },
            // {
            //     key: "sterilizerRental",
            //     text: "1 Sterilizer Rental Included",
            // },
            // {
            //     key: "technicalAdvisorLine",
            //     text: "Technical Advisor Line",
            // },
            // {
            //     key: "preventativeMaintenance",
            //     text: "1 Preventative Maintenance Visit",
            //     retail: "($600 retail)",
            //     note: "Exclusive to Annual Subscribers",
            // },
        ],
    },
    {
        label: "Your Analytics Savings",
        rows: [
            {
                key: "practiceAnalysis",
                text: "Henry Schein Practice Analysis",
                retail: "($699 retail)",
            },
            {
                key: "feeAnalysis",
                text: "Henry Schein Fee Analysis",
                retail: "($149 retail)",
            },
            {
                key: "hsRevenueAnalysis",
                text: "HS Revenue Analysis",
                retail: "($599 retail)",
            },
        ],
    },
    {
        label: "Supplies Savings",
        small: "(Last 12 Months)",
        rows: [
            {
                key: "suppliesSavings",
                text: "Savings on Dental Merchandise Purchases",
                // retail: "($699 retail)",
            },
        ],
    },
];

export const defaultData = {
    date: "9/29/2026",
    customerName: "Altadonna, Darren | 4391299",
    consultant: "BRIAN EVANS",
    memberSince: "5/5/2025",
    points: {
        balance: { points: "59,876", value: "$299" },
        redeemed: { points: "102,300", value: "$512" },
    },
    benefits: [
        {
            label: "Your Points Earnings",
            rows: [
                { text: "5X Points from Henry Schein Products", value: "$351" },
                { text: "3X Points from Equipment", value: "$0" },
                { text: "Exclusive Bonus Points", value: "$0" },
                { text: "1.5X Points on All Other Purchases", value: "$326" },
            ],
        },
        {
            label: "Your Shipping Savings",
            rows: [{ text: "On Merchandise", value: "$820" }],
        },
        {
            label: "Your Service Savings",
            rows: [
                { text: "44% Service Labor Discount", value: "$633" },
                { text: "1 Sterilizer Rental Included", value: "$0" },
                { text: "Technical Advisor Line", value: "$0" },
                {
                    text: "1 Preventative Maintenance Visit",
                    retail: "($600 retail)",
                    note: "Exclusive to Annual Subscribers",
                    value: "$0",
                },
            ],
        },
        {
            label: "Your Analytics Savings",
            rows: [
                { text: "Henry Schein Practice Analysis", retail: "($699 retail)", value: "$0" },
                { text: "Henry Schein Fee Analysis", retail: "($149 retail)", value: "$149" },
            ],
        },
    ],
    total: "$2,279",
};


export default function ViewMyBenefitStatement(props) {
    const { state, dispatch } = useContext(Context);
    const downloadRef = useRef(null);
    const { page, setDisableDropdown } = props;
    const { viewMyBenefitStatement } = report();
    const classes = useStyles();
    const { t, i18n } = useTranslation()
    const [states, setstates] = useState({
        loading: false,
        data: null,
        downloadPending: false
    });
    const { trackWithGTM } = useTrackWithGTM()
    useEffect(() => {
        // 🔹 Log page view
        logEvent({
            event_type: "page_view",
            event_name: "View my Statements",
            user_id: state?.userInfo?.user_id,
            session_id: state?.userInfo?.session_id,
        });
    }, []);
    const setStates = useCallback((newState) => {
        setstates((states) => ({ ...states, ...newState }));
    }, []);

    // useEffect(() => {
    //     handleViewMyBenefitStatement()

    // }, []);

    // useEffect(() => {
    //     if (!states.downloadPending || !states.data) return;

    //     const downloadButton = downloadRef.current;

    //     if (downloadButton) {
    //         downloadButton.click();
    //         setStates({ downloadPending: false });
    //     }
    // }, [states.downloadPending, states.data]);


    async function handleViewMyBenefitStatement() {
        setStates({ loading: true });

        let url;

        try {
            const payload = {
                lId: state?.ALA?.loyalty_id,
                shipto: state?.ACA?.customer_account_number
            };
            // console.log(state, 'state.ALA');
            

            const res = await viewMyBenefitStatement(payload);

            if (res?.message !== "Ok" || !res?.data) {
                console.error("Invalid API response:", res);
                return;
            }

            const { data } = res;

            const benefits = benefitConfig.map((section) => ({
                ...section,
                rows: section.rows.map((row) => ({
                    ...row,
                    value: data?.benefits?.[row.key] ?? 0,
                })),
            }));

            const stateData = {
                customerName: data?.customerName,
                billTo: data?.billTo,
                memberSince: data?.memberSince,
                signatureSince: data?.signatureSince,
                date: data?.date,
                points: data?.points,
                benefits,
                total: data?.total
            };

            // Generate PDF using the API response data
            const blob = await pdf(
                <BenefitStatementPDF data={stateData} />
            ).toBlob();

            // Trigger automatic download
            url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `BenefitStatement ${moment().format(
                "MM-DD-YYYY_h-mm-A"
            )}.pdf`;

            document.body.appendChild(link);
            link.click();
            link.remove();

            setStates({ data: stateData });
        } catch (error) {
            console.error("Benefit statement PDF error:", error);
        } finally {
            if (url) {
                setTimeout(() => URL.revokeObjectURL(url), 1000);
            }

            setStates({
                loading: false,
                downloadPending: false,
            });
        }
    }


    // function handleSetYearsDropDown() {
    //     let arr = [];
    //     let tempYear = moment().subtract(1, 'y').format('YYYY')

    //     let stopYear = state?.ALA?.["Loyalty_Account.reactivation_date"]
    //         ? moment(state?.ALA?.["Loyalty_Account.reactivation_date"]).format('YYYY')
    //         : "2023";
    //     arr.push(tempYear);
    //     while (tempYear != stopYear) {
    //         tempYear = moment(tempYear).subtract(1, 'y').format('YYYY');
    //         arr.push(tempYear)
    //     }
    //     setStates({ yearsDropDown: arr });
    // }

    // CustomerStatus api func
    // const handleGetCustomerStatus = async (type) => {
    //     try {
    //         setDisableDropdown(true);
    //         let values = {};
    //         values = {
    //             startDate: moment(states.selectedYear).startOf('year').format("MM/DD/YYYY"),
    //             endDate: moment(states.selectedYear).endOf('year').format("MM/DD/YYYY"),
    //             loyaltyId: state?.ALA?.loyalty_id,
    //         };
    //         let res = await annualRewardStatmentAPI(values);

    //         if (res && res.data) {
    //             dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
    //             if (type === "excel") {
    //                 setStates({
    //                     excelData: res?.data,
    //                     response: true,
    //                     pLoading: false,
    //                     eLoading: false,
    //                 });
    //             } else if (type === "pdf") {
    //                 setStates({
    //                     pdfData: res?.data,
    //                     response: true,
    //                     pLoading: false,
    //                     eLoading: false,
    //                 });
    //             }
    //             setDisableDropdown(false);
    //             return true;
    //         }
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };

    const locale = i18n.language == 'fr' ? fr : enUS;

    return (
        <div style={{ marginTop: 20 }}>
            <div className={classes.headText}>{t('My Benefit Statement')}</div>
            <div className={classes.headText}>
            </div>
            {/* <Grid item style={{ flex: "none", marginTop: 10 }} className="pending-form-gp">
                <React.Fragment>
                    <button
                        type="button"
                        style={{ height: 40, width: "18%", fontSize: 14 }}
                        className={`${classes.dash_1_tab_1} ${classes.earnedBtn}`}
                    >
                        {t("Select Year")}
                    </button>
                </React.Fragment>
                <span>
                    <CssTextField
                        variant="outlined"
                        id={"dropdown"}
                        select
                        type={"text"}
                        className={classes.earnedInput}
                        style={{ height: 40, width: "18%" }}
                        required
                        value={states.selectedYear}
                        onChange={(e) => {
                            setStates({ selectedYear: e.target.value, pdfData: [] })

                        }}
                    >
                        {states?.yearsDropDown?.map(year => <MenuItem value={year} key={year}>
                            {year}
                        </MenuItem>)}
                    </CssTextField>
                </span>

            </Grid> */}

            {<div className={classes.exportAndPreview}>
                {/* <div className={classes.headText} style={{ marginTop: 20 }}>{states?.selectedYear} Rewards Statement</div> */}
                {/* {(state?.userInfo?.role_id == 10 || state?.userInfo?.role_id == 3 || state?.userInfo?.role_id == 13) && <Button
                    className={classes.exportBtn}
                    style={{ marginLeft: 0 }}
                    onClick={async () => {
                        // logEvent({
                        //     event_type: "button_click",
                        //     event_name: "export-excel", 
                        //     user_id: state?.userInfo?.user_id,
                        //     session_id: state?.userInfo?.session_id,
                        //     page_url: window.location.pathname,
                        //   });
                        //   trackWithGTM({
                        //     database: state?.userInfo?.loyalty_organization_name,
                        //     event: "click",
                        //     pathname: window.location.pathname,
                        //     userId: state?.userInfo?.user_id,
                        //     role_id:state?.userInfo?.role_id,
                        //     allstate:state
                        //   });
                        setStates({
                            response: false,
                            excelData: [],
                            eLoading: true,
                            excelBtnActive: true,
                            pdfBtnActive: false,
                        });
                        // let res = await handleGetCustomerStatus("excel");
                        // if (res) {
                            console.log("csv read")
                            document.getElementById("csv").click();
                        // }
                    }}
                    disabled={states.eLoading || states.pLoading}
                >
                    {states.eLoading && states.excelBtnActive ? (
                        <React.Fragment>
                            <CircularProgress
                                style={{ height: 25, width: 25 }}
                                variant="determinate"
                                value={state.reportResCount}
                            />{" "}
                            &nbsp;
                            <span style={{ color: "#305698", fontWeight: "bold" }}>
                                {state.reportResCount == 0 ? (
                                    <div className="snippet">
                                        <div className="stage">
                                            <div className="dot-typing-e"></div>
                                        </div>
                                    </div>
                                ) : (
                                    `${state.reportResCount}%`
                                )}
                            </span>
                        </React.Fragment>
                    ) : (
                        t("Export as excel")
                    )}
                </Button>} */}
                {/* <StatementXLSX
                    states={states}
                    startDate={moment(states?.selectedYear).startOf('year').format('MMM DD, YYYY')}
                    endDate={moment(states?.selectedYear).endOf('year').format('MMM DD, YYYY')}
                    page={page}
                /> */}
                <Button
                    className={classes.exportBtn}

                    onClick={handleViewMyBenefitStatement}

                    // onClick={async () => {                    
                    // logEvent({
                    //     event_type: "button_click",
                    //     event_name: "export-PDF", 
                    //     user_id: state?.userInfo?.user_id,
                    //     session_id: state?.userInfo?.session_id,
                    //     page_url: window.location.pathname,
                    //   });
                    //   trackWithGTM({
                    //     database: state?.userInfo?.loyalty_organization_name,
                    //     event: "click",
                    //     pathname: window.location.pathname,
                    //     userId: state?.userInfo?.user_id,
                    //     role_id:state?.userInfo?.role_id,
                    //     allstate:state
                    //   });
                    // setStates({
                    //     response: false,
                    //     pdfData: [],
                    //     eLoading: true,
                    //     excelBtnActive: false,
                    //     pdfBtnActive: true,
                    // });
                    // let res = await handleGetCustomerStatus("pdf");
                    // }}
                    disabled={states.loading}
                >
                    {/* {states.loading ? (
                        <React.Fragment>
                            <CircularProgress
                                style={{ height: 25, width: 25 }}
                                variant="determinate"
                                value={state.reportResCount}
                            />{" "}
                            &nbsp;
                            <span style={{ color: "#305698", fontWeight: "bold" }}>
                                {state.reportResCount == 0 ? (
                                    <div className="snippet">
                                        <div className="stage">
                                            <div className="dot-typing-e"></div>
                                        </div>
                                    </div>
                                ) : (
                                    `${state.reportResCount}%`
                                )}
                            </span>
                        </React.Fragment>
                    ) : t(
                        "Download PDF"
                    )} */}
                    {states.loading ? "Generating PDF..." : t("Download PDF")}
                </Button>

                {/* {states?.data && Object.keys(states.data).length > 0 && (
                    <PDFDownloadLink
                        style={{ display: "none" }}
                        document={<BenefitStatementPDF data={states.data} />}
                        fileName={`BenefitStatement ${moment().format("MM-DD-YYYY_h-mm-A")}.pdf`}
                    >
                        {({ loading: pdfLoading }) => (
                            <button
                                ref={downloadRef}
                                id="download-pdf"
                                type="button"
                                disabled={pdfLoading}
                            >
                                Download PDF
                            </button>
                        )}
                    </PDFDownloadLink>
                )} */}

                {(states.loading) && <div style={{ color: 'red', marginLeft: 10 }}>*Please wait don't reload the page, system is processing</div>}
            </div>}
        </div>
    );
}
